import { ComponentPropsWithRef } from "react";

export const ShieldIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 19 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.09961 21.1C9.09961 21.1 17.0996 17.1 17.0996 11.1V4.09998L9.09961 1.09998L1.09961 4.09998V11.1C1.09961 17.1 9.09961 21.1 9.09961 21.1Z"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6992 8.74997L7.99922 14.45L4.44922 10.875L5.54922 9.77497L8.07422 12.3L12.6492 7.72498L13.6992 8.74997Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.6"
    />
  </svg>
);
